export interface IRelease {
  releasedFromId: string;
  releasedToId: string;
  releasedToOrganizationName: string;
  requestedById: string | null;
  status: IReleaseStatus;
}

export enum IReleaseStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Removed = 'Removed'
}
